/** Route segments, under the `me` route. */
const PATH = 'password';
const CONFIRM_PATH = 'confirm';

export { CONFIRM_PATH, PATH };
